@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.SubnavItem {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  display: inline-block;

  a {
    text-decoration: none;
    color: $color-grey-B;
    display: flex;
    height: 40px;
    line-height: 40px;
    outline: none;
    font-weight: 600;
    padding: 8px 16px;

    &:hover,
    &:focus {
      color: $theme-color-tab-label-hover;
    }
  }

  [aria-current] {
    border-bottom: 2px solid $color-primary-purple;
    color: $theme-color-tab-label-selected;
  }
}
